import React, { useState } from "react";

const ReminderModal = ({ isOpen, onClose, appointment, onSetReminder }) => {
  const [reminderTime, setReminderTime] = useState(15); // Default to 15 minutes

  const handleSetReminder = () => {
    onSetReminder(reminderTime);
  };

  if (!isOpen || !appointment) {
    return null;
  }

  const dateStr = (() => {
    const ts = appointment.startTime || appointment.dateTime;
    return ts && typeof ts.toDate === "function"
      ? ts.toDate().toLocaleDateString()
      : "";
  })();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-2xl font-semibold mb-4">Set Reminder</h2>
        <p className="mb-4">
          Set a reminder for the appointment with{" "}
          <span className="font-semibold">{appointment.doctorName}</span>
          {" on "}
          {dateStr}.
        </p>
        <div className="flex items-center mb-4">
          <input
            type="number"
            value={reminderTime}
            onChange={(e) => setReminderTime(e.target.value)}
            className="w-24 p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            min="1"
          />
          <span className="ml-2">minutes before the appointment</span>
        </div>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={handleSetReminder}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
          >
            Set Reminder
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReminderModal;
